import Vue from 'vue'; 
//导入基础css
import 'src/assets/css/base.css'

//导入前端UI  按需引入
import {Notification,OptionGroup,InputNumber,Pagination,CheckboxGroup,Checkbox,Tooltip,Input,Select,Option,Message,MessageBox,Loading,Icon,DatePicker,Switch,Menu,submenu,menuItem,menuItemGroup,dropdown,dropdownItem,dropdownMenu,col,row,Dialog,button,table,tableColumn,upload } from 'element-ui'

Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;
Vue.prototype.$box = MessageBox;
Vue.use(OptionGroup);
Vue.use(InputNumber);
Vue.use(Pagination);
Vue.use(CheckboxGroup);
Vue.use(Checkbox);
Vue.use(Tooltip);
Vue.use(Input);
Vue.use(Select);
Vue.use(Option);
Vue.use(Loading);
Vue.use(Icon);
Vue.use(Menu);
Vue.use(submenu);
Vue.use(menuItem);
Vue.use(menuItemGroup);
Vue.use(dropdown);
Vue.use(dropdownItem);
Vue.use(dropdownMenu);
Vue.use(col);
Vue.use(row);
Vue.use(button);
Vue.use(Dialog);
Vue.use(table);
Vue.use(tableColumn);
Vue.use(upload);
Vue.use(Switch);
Vue.use(DatePicker);


// WEBPACK FOOTER //
// ./src/config/ui-config.js